import React from 'react';
import App from '../App/App.jsx';
import ReactYoutube from 'react-youtube';
import awvideo from 'aw-video-player';
import MobileDetect from 'mobile-detect';


class VideoPlayer extends React.Component {
  
  componentDidMount() {
    const baseurl = "https://video.asiaweekly.com/videos";
    if(this.props.slug) {
      awvideo(this.refs.playerel,{
        dash: `${baseurl}/${this.props.slug}/dash/manifest.mpd`,
        hls: `${baseurl}/${this.props.slug}/hls/multi_bitrate_playlist.m3u8`,
        mp4: `${baseurl}/${this.props.slug}/mp4/default.mp4`
      });
      
      /*let mobiledetect = new MobileDetect(navigator.userAgent||navigator.vendor||window.opera);
      if(mobiledetect.os() === "iOS") {
        let firsttime = true;
        let intervalrepeater = setInterval(() => {
          if(this.refs.playerel.readyState>=1 && this.props.onCanPlay && firsttime) {
            firsttime = false;
            this.refs.playerel.addEventListener("customcanplay",this.props.onCanPlay);
            var event = new CustomEvent('customcanplay', { 'target': this.refs.playerel });
            this.refs.playerel.dispatchEvent(event);
            clearInterval(intervalrepeater);
          }
        },1000)
      }*/
       
    }
  }
  
  
  getComponent() {
    let props = this.props;
    if(props.youtubeId) {
      return (<ReactYoutube 
        videoId={props.youtubeId}        // required -> e.g. "XxVg_s8xAms"
        opts={{width:"100%",height:"100%"}}  // defaults -> {}
        onReady={props.onCanPlay || function(){} } // defaults -> noop
        onPlay={props.onPlay || function(){} }           // defaults -> noop
        onEnd={props.onEnded || function(){} }            // defaults -> noop
        onPause={props.onPause || function(){} }
        onError={props.onError || function(){} }
      />);
    } else if(props.srcMP4 || props.srcWEBM) {
      let srcarray = [];
      if(props.srcMP4) {
        srcarray.push(<source key="mp4source" src={props.srcMP4} type="video/mp4"/>)
      }
      if(props.srcWEBM) {
        srcarray.push(<source key="webmsource" src={props.srcWEBM} type="video/webm"/>)
      }
      
      return (<video
        ref="playerel"
        onLoadedMetadata={props.onCanPlay || function(){} }
        onPlay={props.onPlay || function(){} }
        onEnded={props.onEnded || function(){} }
        onPause={props.onPause || function(){} }
        onError={props.onError || function(){} } 
        width="100%"
        height="100%"
        controls
        preload="auto"
      >
        {srcarray}
      </video>);
    } else if(props.slug) {
      
      return (<video
        ref="playerel"
        onCanPlay = {props.onCanPlay || function(){} }
        onLoadedMetadata={props.onCanPlay || function(){} }
        onPlay={props.onPlay || function(){} }
        onEnded={props.onEnded || function(){} }
        onPause={props.onPause || function(){} }
        onError={props.onError || function(){} } 
        width="100%"
        height="100%"
        controls
        preload="auto"
      />);
    }
  };
  
  render() { 
    return (<div style={{position:"relative", width:"100%", height: 0, paddingBottom:"56.25%"}}>
      <div style={{position:"absolute", left:0, top:0, width:"100%", height:"100%"}}>
        {this.getComponent()}
      </div>
    </div>);
  }
  
}

VideoPlayer.propTypes = {
    onEnded: React.PropTypes.func,
    onCanPlay: React.PropTypes.func,
    onPlay: React.PropTypes.func,
    onPause: React.PropTypes.func,
    onError: React.PropTypes.func,
    youtubeId: React.PropTypes.string,
    srcMP4: React.PropTypes.string,
    srcWEBM: React.PropTypes.string,
    slug: React.PropTypes.string
};

export default VideoPlayer;


// WEBPACK FOOTER //
// ./src/js/components/VideoPlayer/VideoPlayer.jsx